// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Model = require("./model");
var React = require("react");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Configuration = require("./configuration");
var MaterialUIIcons = require("bs-material-ui-icons/lib/js/src/MaterialUIIcons.js");
var LogoReactSvg = require("./logo-react.svg");
var LogoParlementLiveJpg = require("./logo-parlement-live.jpg");

((require('./about.css')));

var component = ReasonReact.statelessComponent("About");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[
                          Model.ste("\xc3\x80 propos de " + Configuration.config[/* appTitle */1]),
                          React.createElement("img", {
                                className: "logo-react",
                                alt: "Logo de React",
                                src: LogoReactSvg
                              }),
                          React.createElement("img", {
                                className: "logo-react",
                                alt: "Logo du Parlement Live",
                                src: LogoParlementLiveJpg
                              }),
                          React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Delete[/* make */0](/* array */[])))
                        ])));
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/about.re
// module id = 321
// module chunks = 0